import './SplitLayout.css';
export var column = '_6q8dk21-3-15-1';
export var handleDecorations = '_6q8dk22-3-15-1';
export var layout = '_6q8dk20-3-15-1';